import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useCallback } from "react";
import dayjs from "dayjs";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import { useEnumStrings } from "../../enumStrings";
import { goldDatePickerTheme } from "../../../themes";

const useStyles = makeStyles((theme: any) => ({
  formInput: {
    marginTop: "50px",
    paddingBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "265px",
      height: "55px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "431px",
      height: "55px",
    },
    borderRadius: "15px",
  },
  formInputFullWidth: {
    marginTop: "0px",
    paddingBottom: "0px",
    width: "100%",
    borderRadius: "8px",
  },
  selectedValue: {
    backgroundColor: "#F2F2F6",
    borderRadius: "15px",
    [theme.breakpoints.down("sm")]: {
      width: "265px",
      height: "55px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "431px",
      height: "55px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "black",
        borderRadius: "15px",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E1A731",
      },
    },
    "& label.Mui-focused": {
      color: "#E1A731",
    },
    "& label.Mui": {
      color: "black",
    },
  },
  selectedValueFullWidth: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#000000",
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#000000",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E1A731",
        borderWidth: "2px",
      },
    },
    "& label.Mui-focused": {
      color: "#E1A731",
    },
    "& label.Mui": {
      color: "#999",
    },
    "& .MuiInputBase-input": {
      padding: "14px 16px",
      fontSize: "14px",
    },
  },
}));

const ShopLocalCampaignEndDatePicker = ({
  formikSetFieldValue,
  formikErrors,
  formikVal,
  disabled,
  isForStartDate,
  startAfterDate,
  fullWidth,
}: {
  formikSetFieldValue: (a: string, b: number) => void;
  formikErrors: any;
  formikVal: number;
  disabled?: boolean;
  isForStartDate?: boolean;
  startAfterDate?: number;
  fullWidth?: boolean;
}) => {
  const classes = useStyles();

  const handleDateChange = useCallback(
    (val) => {
      formikSetFieldValue(
        isForStartDate ? "startDateUtcMilli" : "endDateUtcMilli",
        isForStartDate
          ? dayjs(val).startOf("day").valueOf()
          : dayjs(val).valueOf()
      );
    },
    [formikSetFieldValue, isForStartDate]
  );

  const enumStrings = useEnumStrings();

  return (
    <FormControl
      className={fullWidth ? classes.formInputFullWidth : classes.formInput}
    >
      <MuiThemeProvider theme={goldDatePickerTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          disabled={disabled}
          minDate={
            (startAfterDate || 0) > 0 ? dayjs(startAfterDate) : undefined
          }
          label={
            fullWidth
              ? undefined
              : isForStartDate
              ? enumStrings.shopLocal.shopLocalDatePicker.contestStartDate
              : enumStrings.shopLocal.shopLocalDatePicker.contestEndDate
          }
          className={
            fullWidth ? classes.selectedValueFullWidth : classes.selectedValue
          }
          format="ll"
          onChange={handleDateChange}
          value={formikVal > 0 ? dayjs(formikVal) : undefined}
          slotProps={
            fullWidth
              ? {
                  textField: {
                    placeholder: "Click to set the dates",
                    InputLabelProps: { shrink: false },
                    InputProps: {
                      endAdornment: (
                        <CalendarTodayOutlinedIcon
                          style={{
                            color: "#000000",
                            fontSize: "20px",
                          }}
                        />
                      ),
                    },
                  },
                }
              : undefined
          }
        />
      </LocalizationProvider>
      </MuiThemeProvider>
      {formikErrors && (
        <FormHelperText
          component="legend"
          style={{
            color: "#f44336",
            paddingLeft: fullWidth ? "0px" : "10px",
            paddingTop: "5px",
            marginBottom: "-5px",
            textAlign: fullWidth ? "left" : "center",
            fontSize: fullWidth ? "12px" : undefined,
          }}
        >
          {formikErrors}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ShopLocalCampaignEndDatePicker;
